import { defineMessages } from "react-intl"

export const messages = defineMessages({
  browse: {
    id: "header.browse",
    defaultMessage: "Browse"
  },
  search: {
    id: "header.search",
    defaultMessage: "Search"
  },
  toggleNavigation: {
    id: "header.toggle-navigation",
    defaultMessage: "Toggle site navigation"
  },
  explore: {
    id: "header.explore",
    defaultMessage: "Explore"
  },
  exploreMulti: {
    id: "header.explore-multi",
    defaultMessage: "<span>Tūhura</span> / <em>Explore</em>"
  },
  exploreMultiWithLineBreak: {
    id: "header.explore-multi-with-line-break",
    defaultMessage: "<span>Tūhura</span> <br/><em>Explore</em>"
  },
  collections: {
    id: "header.collections",
    defaultMessage: "Collections"
  },
  collectionsMulti: {
    id: "header.collections-multi",
    defaultMessage: "Kohinga / <em>Collections</em>"
  },
  collectionsMultiWithLineBreak: {
    id: "header.collections-multi-with-line-break",
    defaultMessage: "<span>Kohinga</span><br/><em>Collections</em>"
  },
  contribute: {
    id: "header.contribute",
    defaultMessage: "Contribute"
  },
  contributeMulti: {
    id: "header.contribute-multi",
    defaultMessage: "Tāpae kōrero / <em>Contribute</em>"
  },
  contributeMultiWithLineBreak: {
    id: "header.contribute-multi-with-line-break",
    defaultMessage: "<span>Tāpae kōrero</span><br/><em>Contribute</em>"
  },
  contributeWithLineBreak: {
    id: "header.contribute-with-line-break",
    defaultMessage: "Contribute"
  },
  myScrapbook: {
    id: "header.my-scrapbook",
    defaultMessage: "My Scrapbook"
  },
  myScrapbookMulti: {
    id: "header.my-scrapbook-multi",
    defaultMessage: "Taku pukamahi / <em>My Scrapbook</em>"
  },
  myScrapbookMultiWithLineBreak: {
    id: "header.my-scrapbook-multi-with-line-break",
    defaultMessage: "<span>Taku pukamahi</span><br/><em>My Scrapbook</em>"
  },
  sets: {
    id: "header.sets",
    defaultMessage: "Sets"
  },
  setsMulti: {
    id: "header.sets-multi",
    defaultMessage: "Sets / <em>Kōputu</em>"
  },
  setsMultiWithLineBreak: {
    id: "header.sets-multi-with-line-break",
    defaultMessage: "<span>Sets</span><br><em>Kōputu</em>"
  },
  contributions: {
    id: "header.contributions",
    defaultMessage: "Contributions"
  },
  contributionsMulti: {
    id: "header.contributions-multi",
    defaultMessage: "Ngā tāpaetanga / <em>Contributions</em>"
  },
  contributionsMultiWithLineBreak: {
    id: "header.contributions-multi-with-line-break",
    defaultMessage: "<span>Ngā tāpaetanga</span><br><em>Contributions</em>"
  },
  profile: {
    id: "header.profile",
    defaultMessage: "Profile"
  },
  loginRegister: {
    id: "header.login-register",
    defaultMessage: "Login/Register"
  },
  logout: {
    id: "header.logout",
    defaultMessage: "Logout"
  },
  login: {
    id: "header.login",
    defaultMessage: "Login"
  },
  register: {
    id: "header.register",
    defaultMessage: "Register"
  },
  backToSearch: {
    id: "header.back-to-search",
    defaultMessage: "Back to Search"
  },
  searchMore: {
    id: "header.search-more",
    defaultMessage: "Search..."
  },
  addTermPhrase: {
    id: "header.add-term-phrase",
    defaultMessage: "Add term/phrase to your current search"
  },
  newTermPhrase: {
    id: "header.new-term-phrase",
    defaultMessage: "Perform a new search for your term/phrase"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/header.js